import {
  THREE,
  Stage,
  PerspectiveView,
  FloorModel,
  PanoramaController,
  // PanoramaTransformController,
  PanoramaGroup,
  // TransformController,
  EventHub,
  Events,
  IndicatorDisplayMode,
  // MouseIndicatorController
} from '@aibee/owlly';
import { EventDispatcher } from 'three';

const ICON_POINT = require('@/assets/views/map/pointer.png');

class OwllyScene extends EventDispatcher {
  constructor(option) {
    super();
    this.container = option.container;
    this.storeData = option.data;
    this.initStage();
    this.initEvents();
  }

  initEvents() {
    this.loadedCount = 0;

    EventHub.on(Events.ELEMENT_LOADED, this.modelLoaded);
    EventHub.on(Events.DID_LOAD_PANORAMA, this.onPresented);
    // EventHub.on(Events.MOVE_TO_PANORAMA, this.MoveTo);

    // EventHub.on(Events.DID_LOAD_PANORAMA,this.onPresented);
    // EventHub.on(Events.ELEMENT_SELECTED, this.onSelected);

    // EventHub.on(Events.PANORAMA_CAMERA_CHANGED, this.onUpdataPose);
  }

  initStage() {
    this.stage = new Stage();
    this.view = new PerspectiveView(this.container);
    this.stage.bindView(this.view);

    this.load_panorama = -1;

    this.panoramaDataList = this.storeData.panorama_list.map((item) => {
      const textureURLs = JSON.parse(item.panorama_images_low);
      const panoramaItemData = {
        pid: item.id,
        seqID: item.seq_id,
        textureURLs,
        neighbourPanoramaIDs: item.visible_panorama_seq_ids,
        position: new THREE.Vector3(item.coordinate.position_x, item.coordinate.position_y, item.coordinate.position_z),
        quaternion: new THREE.Quaternion(item.coordinate.direction_x, item.coordinate.direction_y, item.coordinate.direction_z, item.coordinate.direction_w),
        visible: item.visible,
      };
      return panoramaItemData;
    });


    for (let i = this.panoramaDataList.length - 1; i >= 0; i--) {
      const neighbourPanoramaIDs = this.panoramaDataList[i].neighbourPanoramaIDs.map(value => this.panoramaDataList[value].pid);
      this.panoramaDataList[i].neighbourPanoramaIDs = neighbourPanoramaIDs;
    }

    console.log('this.panoramaDataList:', this.panoramaDataList);

    this.model = new FloorModel(this.storeData.modelPath, false);
    // this.model.setGroundParameters({
    //     downDirection:new THREE.Vector3(0,0,-1),
    //     groundPlane:{
    //         a:this.storeData.ground_expression[0],
    //         b:this.storeData.ground_expression[1],
    //         c:this.storeData.ground_expression[2],
    //         d:this.storeData.ground_expression[3],
    //     }

    // });

    // console.log(this.storeData.ground_expression,this.model.groundParam);

    this.pGroup = new PanoramaGroup(this.panoramaDataList, {
      modelElement: this.model,
      groundParams: {
        downDirection: new THREE.Vector3(0, 0, -1),
      },
      indicatorImageURL: '/textures/pointer.png',
    });

    this.panoramaDataList
      .filter(p => !p.visible)
      .forEach((p) => {
        this.pGroup.setIndicatorVisibility(p.visible, p.pid);
      });
    if (this.view) {
      this.pGroup.addGroupViewConfiguration({
        targetView: this.view,
        indicatorDisplayMode: IndicatorDisplayMode.Show,
        visibleRadius: 25,
      });
      this.pGroup.addViewConfiguration({
        targetView: this.view,
        showBorder: false,
        showSkyBox: true,
      });
    }


    // this.pGroup.addViewConfiguration({
    //   targetView: this.view,
    //   showBorder: false,
    //   showSkyBox: true,
    // });
    // this.pGroup.addGroupViewConfiguration({
    //   targetView: this.view,
    //   indicatorDisplayMode: IndicatorDisplayMode.Show,
    //   visibleRadius: 100,
    // });

    //  控制器
    this.panoCtl = new PanoramaController(this.view, this.pGroup, true);
    this.panoCtl.setMouseClickEnabled(true);
    this.panoCtl.setZoomEnabled(true); // for debug
    this.stage.bindController(this.panoCtl);


    EventHub.on(Events.CLICK_PANORAMA, (pid) => {
      // console.log(`## CLICK_PANORAMA #${pid}`);
      setTimeout(() => {
        this.panoCtl.moveToPanorama(pid);
        this.dispatchEvent({ type: 'click_panorama', pid });
      }, 500);
    });


    // this.indicatorController = new MouseIndicatorController('/textures/pointer.png');
    // this.indicatorController.bindView(this.view);
    // this.indicatorController.setTarget(this.floorModel);
    // this.stage.bindController(this.indicatorController);


    // 新建一个TransformController，用来响应点击事件
    // this.transformCtrl = new TransformController(this.view);
    // this.transformCtrl.set2DElementDetectionRadius(18);
    // this.transformCtrl.setStickVisibility(true, true, true, this.view);

    // this.stage.bindController(this.transformCtrl);

    this.stage.bindElement(this.pGroup);
    this.stage.bindElement(this.model);
  }

modelLoaded= async (...params) => {
  if (params[0] instanceof FloorModel) {
    // lookX, -lookZ, lookY
    await this.panoCtl.lookFromPanorama(
      Number(this.storeData.initial_view.roaming_panorama_id),
      new THREE.Vector3(
        this.storeData.initial_view.roaming_direction_x,
        -this.storeData.initial_view.roaming_direction_z,
        this.storeData.initial_view.roaming_direction_y
      ),
      true
    );

    this.dispatchEvent({ type: 'load_moled' });
  }
}

onPresented = async () => {
  if (this.load_panorama === -1) {
    this.load_panorama = 1;
    this.dispatchEvent({ type: 'loaded_panorama' });
  }
}
}

export default OwllyScene;
